export default "__VITE_ASSET__CkqksSD___"